import { createContext, useContext } from "react";

/**
 * Controls the `prefetch` behaviour of links rendered through `LinkBehaviour`.
 *
 * `undefined` (default) leaves prefetching to the link implementation's default
 * behaviour. `false` disables prefetching for every link rendered inside the
 * provider, which is used to avoid eager App Router prefetch requests for links
 * that are in the DOM but not yet visible to the user (e.g. collapsed navigation).
 */
export const LinkPrefetchContext = createContext<boolean | undefined>(undefined);

export const useLinkPrefetch = () => useContext(LinkPrefetchContext);
